// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"53":"4ca3038d","148":"bac3f049","244":"dea78921","285":"528eef40","433":"074b6488","478":"11502c1e","499":"6e06c976","577":"a38a3f15"}[chunkId] + ".js";
};